export default __webpack_public_path__ + "static/media/Savior's Spite Hammer.15302a2c.jpg";